// extracted by mini-css-extract-plugin
export default {"container":"aboutUs_container__vXr5Z","heading":"aboutUs_heading__r1ss7","iframe":"aboutUs_iframe__mAN-O","rightContent":"aboutUs_rightContent__uQAR-"};